let initialized = false;
let measurementId = "";

export interface AnalyticsUser {
    userId?: string;
    company?: string;
}

export interface AnalyticsProject {
    projectId?: string;
    projectName?: string;
}

const initialize = function(id: string) {
    if (initialized) return;

    initialized = true;
    measurementId = id;

    const script = document.createElement("script");

    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;

    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];

    window.gtag = (...args) => {
        window.dataLayer.push(args);
    };

    window.gtag("js", new Date());

    window.gtag("config", id);
}

const setUser = function(user?: AnalyticsUser) {
    if (!window.gtag) return;

    window.gtag("config", measurementId, {
        user_id: user?.userId
    });

    window.gtag("set", "user_properties", {
        u_id: user?.userId,
        company: user?.company
    });
}

const trackPage = function(
    path: string,
    project?: AnalyticsProject
) {
    if (!window.gtag) return;

    window.gtag("event", "page_view", {
        page_path: path,
        project_id: project?.projectId,
        project_name: project?.projectName
    });
}

const trackEvent = function(
    eventName: string,
    parameters?: Record<string, unknown>,
    project?: AnalyticsProject
) {
    if (!window.gtag) return;

    window.gtag("event", eventName, {
        ...parameters,
        project_id: project?.projectId,
        project_name: project?.projectName
    });
}

export { initialize, setUser, trackPage, trackEvent }